
<script>
	import { appProfileState } from "../../state/ApplicationState.svelte";
	import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import Dialog from "../../../../../SharedSvelte//Dialog.svelte";
    import ChangeEmail from "./ChangeEmail.svelte";
    import ChangeMfa from "./ChangeMfa.svelte";
	//import ChangePassword from './ChangePassword.svelte';

	let prompt;
	let apiPromise = $state(fetchSecuritySettings()); 
	
	async function fetchSecuritySettings() {
        Loader.display();
        
        try {
            const response = await fetch(`${baseUrl}Security/AuthenticationSettings`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                },
            });

            window.scrollTo(0, 0);

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                //prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
			appProfileState.securityEmail = data.email;
			appProfileState.securityEmailVerified = data.emailVerified;
			appProfileState.securityEnrolledMfa = data.enrolledMFA;

            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching profile security settings:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }
	
</script>

<main>
	<h1 class="mt-3 mb-3">Security Settings</h1> 
	{#await apiPromise}
        <div>Loading...</div>
    {:then data}
        <ChangeEmail />
		<!-- <ChangePassword />  -->
        <ChangeMfa />

        <!-- <pre>{JSON.stringify(data)}</pre> -->
		<!-- <pre>{appProfileState.securityEmail} {appProfileState.securityEmailVerified} {JSON.stringify(appProfileState.securityEnrolledMfa)}</pre> -->

	{:catch error}
            <div class="alert alert-danger">This feature is not currently available</div> 
    {/await}
	
</main>

<Dialog bind:this={prompt} />
